<template>
    <div class="search-layout">
        <client-only>
            <slot name="mobileTabs" :tabs="mobileTabs">
                <teleport v-if="isMobile" to="#under-header">
                    <mobile-search-page-tabs ref="mobileTabs" v-model="mobileTabs" />
                </teleport>
            </slot>
        </client-only>
        <v-container fluid>
            <slot v-if="!isMobile" name="breadcrumbs">
                <breadcrumbs />
            </slot>
            <v-row>
                <v-col cols="12" :xl="!mapExpanded ? 8 : 2" :md="!mapExpanded ? 9 : 3">
                    <v-row class="pt-0">
                        <slot v-if="!isMobile || (isMobile && mobileTabs === 3)" name="preinfo" />

                        <v-col
                            v-show="!isMobile || (isMobile && mobileTabs === 0)"
                            :md="!mapExpanded ? 3 : 12"
                            :xl="!mapExpanded ? 3 : 12"
                        >
                            <slot name="left-sidebar" />
                        </v-col>
                        <v-col v-show="(!mapExpanded && !isMobile) || (isMobile && mobileTabs === 1)" :md="9" xl="9">
                            <slot name="main-content" />
                            <no-offers-label
                                v-if="offersCount === 0 && !searchActive && $conf.public.account.newReservationRequest"
                            />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-show="!isMobile || (isMobile && mobileTabs === 2)">
                    <slot name="right-sidebar" />
                </v-col>
            </v-row>
        </v-container>
        <slot />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import MobileSearchPageTabs from '~/components/snippets/MobileSearchPageTabs.vue'
    import {CHANGE_TAB_MOBILE_EVENT, EventBus, FULL_SCREEN_MODE, SHOW_ON_MAP_EVENT} from '~/utils/event-bus'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import NoOffersLabel from '~src/components/snippets/NoOffersLabel'

    @Component({
        components: {
            NoOffersLabel,
            MobileSearchPageTabs,
            Breadcrumbs,
        },
    })
    export class SearchLayout extends Vue {
        @Prop({default: false}) mapExpanded
        @Prop() offersCount
        @Prop({type: Boolean, default: false}) searchActive
        @Prop({default: null}) tabs

        mobileTabs = 1

        @Watch('tabs')
        onTabsChange(val) {
            this.mobileTabs = val
        }

        @Watch('mobileTabs')
        onMobileTabsChange(tab, prevTab) {
            if (tab === 2) {
                // TODO [P3] Deprecated
                EventBus.$emit(FULL_SCREEN_MODE, true)
            } else if (prevTab === 2) {
                EventBus.$emit(FULL_SCREEN_MODE, false)
            }
        }

        mounted() {
            EventBus.$on(CHANGE_TAB_MOBILE_EVENT, this.setMobileTab)
            if (this.isMobile) {
                EventBus.$on(SHOW_ON_MAP_EVENT, this.showMapTab)
            }
        }

        beforeUnmount() {
            EventBus.$emit(FULL_SCREEN_MODE, false)
            EventBus.$off(CHANGE_TAB_MOBILE_EVENT, this.setMobileTab)
            if (this.isMobile) {
                EventBus.$off(SHOW_ON_MAP_EVENT, this.showMapTab)
            }
        }

        setMobileTab(tab) {
            this.mobileTabs = tab
            window.scrollTo(0, 0)
        }

        showMapTab() {
            this.mobileTabs = 2
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default SearchLayout
</script>
